import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import { useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';

const Add_organization = (props) => {
	document.title = 'Add Organization';
	const history = useHistory();
	const { postRequest } = useRequests();
	React.useEffect(() => {
		if (localStorage.getItem('admin_type') !== 'admin') {
			history.replace('/dashboard');
		}
	}, [history]);
	const [AlertData, setAlertData] = useState({ variant: '', message: '' });

	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData({ variant: '', message: '' });
		}, 5000);
	};

	const validationSchema = Yup.object({
		orgName: Yup.string().required("Organization Name is required"),
		location: Yup.string().required("Location is required"),
		supervisor: Yup.string().required("Supervisor Name is required"),
		email: Yup.string().email("Invalid email").required("Email is required"),
		mobile: Yup.string()
			.required("Mobile Number is required")
			.matches(/^[0-9]+$/, "Mobile number must be digits only!")
			.test(
				"len",
				"Mobile number should be 9 digits for Spain/France/Belgium, 10 digits for other countries!",
				function (value) {
					// You can add country code logic here if you add a country code selector
					// For now, just check for 9 or 10 digits
					if (!value) return false;
					return value.length === 9 || value.length === 10;
				}
			),
	});

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			orgName: "",
			location: "",
			supervisor: "",
			email: "",
			mobile: "",
		},
		validationSchema,
		onSubmit: async () => {
			try {
				const payload = {
					organization_name: formik.values.orgName,
					location: formik.values.location,
					supervisor: formik.values.supervisor,
					email: formik.values.email,
					mobile: formik.values.mobile,
				};

				let submit1 = document.getElementById('submit1');
				submit1.disabled = true;
				submit1.textContent = 'Processing...';

				const res = await postRequest('add-organization', JSON.stringify(payload));
				if (res && res.code === 200) {
					history.push({
						pathname: '/organization_management',
						state: { code: 200, status: 'success', message: res.message }
					});
				} else {
					setAlertData({ variant: 'error', message: res.message });
				}
				resetAlertData();
				submit1.disabled = false;
				submit1.textContent = 'Submit';
			} catch (error) {
				console.error("Error: ", error);
			}
		}
	});

	const handleFieldChange = (e) => {
		const { name, value } = e.target;
		formik.setFieldValue(name, value);
	};

	return (
		<React.Fragment>
			{AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
			<div className="page-content">
				<Container fluid>
					<Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Add Organization")} />
					<Card>
						<CardBody>
							<Row className="mt-3">
								<Col md={6}>
									<div className="mb-3">
										<Label className="form-label">Organization Name :</Label>
										<Input
											name="orgName"
											type="text"
											placeholder="Enter Organization Name"
											value={formik.values.orgName}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.orgName && !!formik.errors.orgName}
										/>
										{formik.touched.orgName && formik.errors.orgName && (
											<FormFeedback type="invalid">{formik.errors.orgName}</FormFeedback>
										)}
									</div>
								</Col>
								<Col md={6}>
									<div className="mb-3">
										<Label className="form-label">Location :</Label>
										<Input
											name="location"
											type="text"
											placeholder="Enter Location"
											value={formik.values.location}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.location && !!formik.errors.location}
										/>
										{formik.touched.location && formik.errors.location && (
											<FormFeedback type="invalid">{formik.errors.location}</FormFeedback>
										)}
									</div>
								</Col>
							</Row>
							<Row>
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">Supervisor Name :</Label>
										<Input
											name="supervisor"
											type="text"
											placeholder="Enter Supervisor Name"
											value={formik.values.supervisor}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.supervisor && !!formik.errors.supervisor}
										/>
										{formik.touched.supervisor && formik.errors.supervisor && (
											<FormFeedback type="invalid">{formik.errors.supervisor}</FormFeedback>
										)}
									</div>
								</Col>
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">Email :</Label>
										<Input
											name="email"
											type="email"
											placeholder="Enter Email"
											value={formik.values.email}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.email && !!formik.errors.email}
										/>
										{formik.touched.email && formik.errors.email && (
											<FormFeedback type="invalid">{formik.errors.email}</FormFeedback>
										)}
									</div>
								</Col>
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">Mobile Number :</Label>
										<Input
											name="mobile"
											type="text"
											placeholder="Enter Mobile Number"
											value={formik.values.mobile}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.mobile && !!formik.errors.mobile}
										/>
										{formik.touched.mobile && formik.errors.mobile && (
											<FormFeedback type="invalid">{formik.errors.mobile}</FormFeedback>
										)}
									</div>
								</Col>
							</Row>
							<div className="text-left mt-2">
								<button
									type="button"
									id="submit1"
									onClick={(e) => {
										e.preventDefault();
										formik.handleSubmit();
									}}
									className="btn btn-primary me-2"
								>
									Submit
								</button>
							</div>
						</CardBody>
					</Card>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default withTranslation()(Add_organization);
